/**
 * 営業設定 > 同意書編集タブ。
 * v3.1.4 — 将来実装の placeholder。
 *
 * 想定機能: 商談クロージング時に顧客から取得する同意書（取引条件・個人情報利用等）の
 * テンプレート編集。現状は枠のみ用意。
 */
import { FileText } from 'lucide-react';

export function ConsentTab() {
  return (
    <div className="max-w-2xl py-12 text-center text-[var(--text-muted)]">
      <FileText className="size-10 mx-auto mb-3 opacity-40" />
      <p className="text-sm font-medium mb-1">同意書編集（準備中）</p>
      <p className="text-xs">
        商談クロージング時に顧客から取得する同意書テンプレートの編集機能は今後実装予定です。
      </p>
    </div>
  );
}
